import React from 'react';
import { Title, Icon, Subtitle, Link, LazyImage } from '@landing/ui';

import * as styles from './Item.module.scss';

export default function Item({ name, img, position, link, message }) {
  const NameWrapper = link ? Link : 'div';

  return (
    <div className={styles.article}>
      <figure className={styles.author}>
        <LazyImage
          className={styles.authorImg}
          src={img}
          width={50}
          height={50}
          alt={position ?? 'author'}
          style={{
            maxWidth: '100%',
            height: 'auto',
            objectFit: 'cover',
          }}
        />
        <figcaption className={styles.authorInfo}>
          <NameWrapper className={styles.authorNameWrapper} href={link}>
            <Title tag="span" className={styles.authorName}>
              {name}
              {link && <Icon name="linkedin-square" className={styles.linkedinIcon} />}
            </Title>
          </NameWrapper>
          <Subtitle size="md" className={styles.authorPosition}>
            {position}
          </Subtitle>
        </figcaption>
      </figure>
      <Subtitle size="md" className={styles.message}>
        {message}
      </Subtitle>
    </div>
  );
}
